import React, { useState, useEffect } from 'react';

export const Loader = ({ onComplete }) => {
  const [hidden, setHidden] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Плавное увеличение прогресса от 0 до 100%
    const duration = 2800; // общая длительность в мс
    const interval = 50; // шаг обновления в мс
    const steps = duration / interval;
    const increment = 100 / steps;

    const timer = setInterval(() => {
      setProgress(prev => {
        const next = prev + increment;
        return next >= 100 ? 100 : next;
      });
    }, interval);

    // Завершение загрузки
    const endTimer = setTimeout(() => {
      clearInterval(timer);
      setProgress(100);
      setHidden(true);
      setTimeout(onComplete, 800); // Небольшая задержка перед исчезновением
    }, duration);

    return () => {
      clearInterval(timer);
      clearTimeout(endTimer);
    };
  }, [onComplete]);

  return (
    <div className={`loader ${hidden ? 'hidden' : ''}`}>
      <div className="loader-text">Проявка плёнки</div>
      <div className="loader-progress">
        <div 
          className="loader-progress-bar" 
          style={{ width: `${Math.min(progress, 100)}%` }} 
        />
      </div>
      <div className="loader-percent">
        {Math.round(Math.min(progress, 100))}%
      </div>
    </div>
  );
};